module.exports = __webpack_public_path__ + "img/SmaraView.a4145f24.png";